<template>
  <div class="flex_vh100 Order" style="flex-direction: column">
    <!-- 顶部导航 -->
    <van-nav-bar
      title="确认订单"
      left-text="返回"
      left-arrow
      @click-left="goBack"
    >
    </van-nav-bar>

    <!-- 中间内容区域，flex:1 自动填充剩余空间 -->
    <div
      class="flex_vh100"
      style="flex: 1; flex-direction: column; overflow: hidden"
      v-if="goodsInfo"
    >
      <div class="flex_vh100">
        <div class="goodsdetails flex flex-a-c">
          <div class="mrgr20">
            <van-image
              width="2.5rem"
              height="3.5rem"
              fit="cover"
              :src="getImageSrc(goodsInfo.commodityInfo.img_name)"
              class="rounded-image"
            />
          </div>
          <div class="flex flex-column space_between" style="height: 3.5rem">
            <div class="size16 fontWgt">
              <span>{{ goodsInfo.commodityInfo.name }}</span>
            </div>
            <div>
              <span>{{ goodsInfo.commodityInfo.description }}</span>
            </div>
          </div>
        </div>
        <div class="user-search-box">
          <div class="radius" style="background-color: #fff">
            <div class="size14 user-search-text">充值账户：</div>
            <div class="flex flex-a-c">
              <!-- 输入框：只允许数字、最大10位、带清空按钮 -->
              <van-field
                ref="accountInput"
                v-model="number"
                placeholder="请输入充值的账户ID"
                clearable
                @input="handleInput"
                @clear="handleClear"
                class="radius"
              >
                <template v-if="selectDisInfo" #input>
                  <div class="flex flex-a-c space_between" style="width: 100%">
                    <div class="flex flex-a-c">
                      <van-image :src="selectDisInfo.wc_logo" class="avatar" />
                      <div class="flex flex-column">
                        <span class="nickname">{{
                          (selectDisInfo.p_nickName ||
                            selectDisInfo.wc_nickName) +
                          (selectDisInfo.mobile
                            ? "(" + formatMobile(selectDisInfo.mobile) + ")"
                            : "")
                        }}</span>
                        <span class="size12" style="color: #999">{{
                          selectDisInfo.number
                        }}</span>
                      </div>
                    </div>
                    <div @click="handleClear()">
                      <van-icon name="close" size="22" color="red" />
                    </div>
                  </div>
                </template>
              </van-field>

              <van-button
                plain
                class="size12 wdth80 radius"
                @click="GetMine()"
                v-if="!selectDisInfo"
                >本微信</van-button
              >
            </div>

            <!-- 自动弹出的下拉列表 -->
            <van-popup
              v-model="showPopup"
              position="bottom"
              :style="{ height: '40%' }"
              round
            >
              <div class="user-list">
                <van-cell-group v-if="disInfo">
                  <van-cell @click="selectUser()" is-link>
                    <div class="flex flex-a-c">
                      <van-image :src="disInfo.wc_logo" class="avatar" />
                      <div class="flex flex-column">
                        <span class="nickname">{{
                          (disInfo.p_nickName || disInfo.wc_nickName) +
                          (disInfo.mobile ? "(" + formatMobile(disInfo.mobile) + ")" : "")
                        }}</span>
                        <span class="size12" style="color: #999">{{
                          disInfo.number
                        }}</span>
                      </div>
                    </div>
                  </van-cell>
                </van-cell-group>

                <!-- 空状态 -->
                <div v-else class="empty">未查询到匹配用户</div>
              </div>
            </van-popup>
          </div>
        </div>
        <div>
          <van-radio-group v-model="pb_id">
            <van-cell-group class="payType">
              <van-cell
                v-for="(item, idx) in goodsInfo.lstPayInfo"
                :key="idx"
                clickable
                @click="pb_id = item.pb_id"
                class="radius"
              >
                <div class="flex flex-a-c">
                  <div class="flex flex-a-c">
                    <van-image
                      v-if="item.payType == 1"
                      width="1rem"
                      height="1rem"
                      fit="cover"
                      :src="getImageSrc('weixin')"
                    />
                    <van-image
                      v-if="item.payType == 2"
                      width="1rem"
                      height="1rem"
                      fit="cover"
                      :src="getImageSrc('zhifubao')"
                    />
                    <div class="mrgl20 fontWgt">{{ item.name }}</div>
                  </div>
                  <div>{{ item.payName }}</div>
                  <div
                    v-if="
                      goodsInfo.lstDiscountInfo_pay.filter((e) => {
                        return e.pb_id == item.pb_id;
                      }).length > 0
                    "
                    class="discount-corner"
                  >
                    折扣
                  </div>
                </div>
                <template #right-icon>
                  <van-radio :name="item.pb_id"> </van-radio>
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>

        <!-- 充值账户历史记录 -->
        <div
          v-if="rechargeHistory.length > 0"
          class="radius flex_vh100"
          style="background-color: #fff; margin: 8px"
        >
          <div class="size14 user-search-text">充值记录</div>
          <div class="history-list flex_vh100" style="overflow-y: auto">
            <div
              v-for="(item, index) in rechargeHistory"
              :key="index"
              class="flex flex-a-c history-item"
              @click="selectFromHistory(item)"
            >
              <van-image :src="item.wc_logo" class="avatar" />
              <div class="flex flex-column" style="flex: 1">
                <span class="nickname">{{
                  (item.p_nickName || item.wc_nickName) +
                  (item.mobile ? "(" + formatMobile(item.mobile) + ")" : "")
                }}</span>
                <span class="size12" style="color: #999">{{
                  item.number
                }}</span>
              </div>
              <van-icon
                name="close"
                size="18"
                color="#999"
                @click.stop="deleteHistory(index)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="mrgb20 flex justify-content_end"
      style="background: white; padding: 8px"
    >
      <div class="flex flex-a-c">
        <div>
          <span class="size14">合计</span>
          <span class="size18 red">￥{{ calAmount() }}</span>
          <span
            v-if="calAmount() != goodsPrice"
            style="text-decoration: line-through; margin-left: 8px; color: #999"
          >
            ¥{{ goodsPrice }}
          </span>
        </div>
        <div class="flex justify-content mrgr10 mrgl10" @click="pay()">
          <van-button color="#1989fa" round class="wdth120"
            >立即支付</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CheckPayToken,
  GetMallGoodsDetails,
  WxH5Pay,
  GetAccountName,
} from "../api/mallapi.js";
import { Toast } from "vant";
import WxPay from "@/utils/wxPay";
export default {
  name: "Order",
  data() {
    return {
      tokenCode: "",
      commodityId: "",

      number: "",
      disInfo: null,
      selectDisInfo: null,
      showPopup: false,

      userInfo: {},

      pb_id: "",
      goodsInfo: null,

      goodsPrice: "",

      rechargeHistory: [],
    };
  },

  watch: {
    showPopup(val) {
      if (val && this.$refs.accountInput) {
        this.$refs.accountInput.$el.querySelector("input").blur();
      }
    },
  },

  methods: {
    // 清空输入框 & 清除用户信息
    handleClear() {
      this.number = "";
      this.disInfo = null;
      this.selectDisInfo = null;
      this.showPopup = false;
    },

    // 输入监听
    async handleInput(number) {
      this.number = number;
      this.disInfo = null;

      // 长度达到10位 → 自动查询
      if (this.number.length === 10) {
        await this._getAccountName(this.number);
      } else {
        this.showPopup = false;
      }
    },

    selectUser() {
      this.selectDisInfo = JSON.parse(JSON.stringify(this.disInfo));
      this.showPopup = false;
    },

    // 加载充值历史记录
    loadRechargeHistory() {
      var history = localStorage.getItem("rechargeHistory");
      if (history) {
        this.rechargeHistory = JSON.parse(history);
      }
    },

    // 保存充值账户到历史记录
    saveRechargeHistory() {
      if (!this.selectDisInfo) return;

      var history = this.rechargeHistory || [];
      // 检查是否已存在
      var exists = history.findIndex(
        (item) => item.accountId === this.selectDisInfo.accountId
      );

      if (exists > -1) {
        // 已存在则移到最前面
        history.splice(exists, 1);
      }

      // 添加到最前面
      history.unshift({
        accountId: this.selectDisInfo.accountId,
        number: this.selectDisInfo.number,
        wc_nickName: this.selectDisInfo.wc_nickName,
        wc_logo: this.selectDisInfo.p_logo
          ? this.selectDisInfo.p_logo
          : this.selectDisInfo.wc_logo,
        p_nickName: this.selectDisInfo.p_nickName,
        mobile: this.selectDisInfo.mobile,
      });

      // 最多保存30条
      if (history.length > 30) {
        history = history.slice(0, 30);
      }

      this.rechargeHistory = history;
      localStorage.setItem("rechargeHistory", JSON.stringify(history));
    },

    // 从历史记录选择账户
    selectFromHistory(item) {
      this.selectDisInfo = item;
      this.number = item.number;
    },

    // 格式化手机号：有_的取_后面的，否则取整个
    formatMobile(mobile) {
      if (!mobile) return "";
      if (mobile.includes("_")) {
        return mobile.split("_")[1] || "";
      }
      return mobile;
    },

    // 删除历史记录
    deleteHistory(index) {
      this.rechargeHistory.splice(index, 1);
      localStorage.setItem(
        "rechargeHistory",
        JSON.stringify(this.rechargeHistory)
      );
    },

    async Init() {
      this.tokenCode = this.$route.query.token;
      this.commodityId = this.$route.query.commodityId;

      if (this.tokenCode) {
        await this._checkPayToken();
      }

      var userInfo = this.getUserInfo();
      if (!userInfo) {
        return;
      }
      this.userInfo = userInfo;

      await this._getMallGoodsDetails();
      this.loadRechargeHistory();
    },

    async GetMine() {
      await this.handleInput(this.userInfo.account_no);
      this.selectUser();
    },

    goBack() {
      // 获取上一个页面的路径
      const previousPath = window.history.state?.back || "/";
      // 检查路由是否存在
      if (this.isRouteExists(previousPath)) {
        this.$router.go(-1); // 返回上一页
      } else {
        // 路由不存在，跳转到首页
        this.$router.push({
          name: "Mall",
        });
      }
    },

    isRouteExists(path) {
      // 检查路由表
      const routes = this.$router.getRoutes();
      return routes.some((route) => {
        if (route.path === path) return true;
        // 处理动态路由
        if (route.path.includes(":")) {
          const pattern = route.path.replace(/:[^/]+/g, "([^/]+)");
          const regex = new RegExp(`^${pattern}$`);
          return regex.test(path);
        }
        return false;
      });
    },

    // 安全获取图片路径
    getImageSrc(path) {
      try {
        return require(`@/assets/images_app/${path}.png`);
      } catch (e) {
        return require("@/assets/images/bgcenter.png");
      }
    },

    calAmount() {
      var disPrice = this.goodsInfo.commodityInfo.price;
      this.goodsInfo.lstDiscountInfo_goods.forEach((e) => {
        //百分比
        if (e.d_type == 1) {
          disPrice = disPrice * (e.d_value / 10000);
        }
        //直减
        if (e.d_type == 2) {
          disPrice = disPrice - e.d_value;
        }
      });

      disPrice = Math.max(disPrice, 0);
      this.goodsPrice = (disPrice / 100).toFixed(2);

      this.goodsInfo.lstDiscountInfo_pay.forEach((e) => {
        if (e.pb_id == this.pb_id) {
          //百分比
          if (e.d_type == 1) {
            disPrice = disPrice * (e.d_value / 10000);
          }
          //直减
          if (e.d_type == 2) {
            disPrice = disPrice - e.d_value;
          }
        }
      });

      disPrice = Math.max(disPrice, 0);
      return (disPrice / 100).toFixed(2);
    },

    getUserInfo() {
      var userInfo = localStorage.getItem("userInfo");
      if (userInfo) {
        return JSON.parse(userInfo);
      }
      var prePath = this.buildNewPath();
      this.$router.push({
        name: "Login",
        query: {
          prePath: prePath,
        },
      });
      return null;
    },

    buildNewPath() {
      const prePath = window.location.hash
        ? window.location.hash.substring(1) // hash模式
        : window.location.pathname + window.location.search; // history模式

      // 分离路径和查询部分
      const [path, queryString] = prePath.split("?");

      var newHash = path;
      if (queryString) {
        // 使用 URLSearchParams 处理参数
        const searchParams = new URLSearchParams(queryString);
        searchParams.delete("token");

        // 重新构建新的查询字符串
        const newQueryString = searchParams.toString();
        newHash = newQueryString ? `${path}?${newQueryString}` : path;
      }

      return newHash;
    },

    pay() {
      var payInfo = this.goodsInfo.lstPayInfo.filter((e) => {
        return e.pb_id == this.pb_id;
      });

      var payType = 0;
      if (payInfo.length > 0) {
        payType = payInfo[0].payType;
      }

      if (!this.selectDisInfo) {
        Toast.fail({
          message: "请选择入账目标账户",
          duration: 3000,
        });
        return;
      }

      // 保存充值账户到历史记录
      this.saveRechargeHistory();

      //微信支付
      if (payType == 1) {
        this._wxH5Pay().then(async (res) => {
          if (res.Success && res.NeedPay) {
            // 调起微信支付
            await WxPay.wxPay(res.payResult);
            // 3. 支付成功
            Toast.success({
              message: "支付成功",
              duration: 1500,
              onClose: () => {
                // Toast 关闭后跳转
                this.$router.push({
                  name: "Mall",
                });
              },
            });
          } else if (res.Success && !res.NeedPay) {
            Toast.success({
              message: "支付成功",
              duration: 1500,
              onClose: () => {
                // Toast 关闭后跳转
                this.$router.push({
                  name: "Mall",
                });
              },
            });
          } else {
            Toast.fail({
              message: res.Message,
              duration: 3000,
            });
          }
        });
      }
    },

    //读取商城商品详情
    _getMallGoodsDetails() {
      var par = {
        Id: this.commodityId,
      };
      return GetMallGoodsDetails(par).then((res) => {
        this.goodsInfo = res;
        if (res.lstPayInfo.length > 0) {
          this.pb_id = res.lstPayInfo[0].pb_id;
        }
      });
    },

    //根据token验证是否登录
    _checkPayToken() {
      var par = {
        tokenCode: this.tokenCode,
      };
      return CheckPayToken(par).then((res) => {
        localStorage.setItem(
          "userInfo",
          JSON.stringify({
            accountId: res.accountId,
            logonId: res.logonId,
            account_no: res.number,
            loginType: res.loginType,
          })
        );
      });
    },

    //微信H5支付
    _wxH5Pay() {
      var par = {
        logon_id: this.userInfo.logonId,
        accountId: this.userInfo.accountId,
        dst_id: this.selectDisInfo.accountId,
        pb_id: this.pb_id,
        useTo: 1,
        useCxt: this.goodsInfo.commodityInfo.commodityId,
      };
      return WxH5Pay(par);
    },

    //读取用户基本信息
    _getAccountName(account_no) {
      var par = {
        account_no: account_no,
      };
      return GetAccountName(par).then((res) => {
        if (res.accountId != 0) {
          this.disInfo = res;
          if (this.disInfo.p_logo) {
            this.disInfo.wc_logo = this.disInfo.p_logo;
          }
        } else {
          this.disInfo = null;
        }
        this.showPopup = true;
      });
    },
  },
  mounted() {
    this.Init();
  },
};
</script>

<style scoped>
.radius {
  border-radius: 8px;
}
.goodsdetails {
  background: white;
  margin: 8px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  height: 150px;
  padding: 8px;
}
.payType {
  background: white;
  margin: 8px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.btbg-container {
  width: 160px;
  height: 40px;
  background-image: url("~@/assets/images_app/lijifukuan.png");
  background-size: cover;
  background-position: center; /* 居中显示 */
  background-repeat: no-repeat;
  border: none; /* 根据需要去掉默认边框 */
  font-size: 18px;
  color: #fffdff;
  line-height: 40px;
}
.discount-corner {
  position: absolute;
  top: 0;
  right: 140px;
  background: linear-gradient(135deg, #ff6b6b, #ff4757);
  color: white;
  font-size: 12px;
  font-weight: bold;
  padding: 3px 6px;
  border-radius: 0 0 0 12px;
  z-index: 1;
  box-shadow: -2px 2px 4px rgba(0, 0, 0, 0.1);
}
.user-search-box {
  padding: 15px 0.21333rem;
}
.user-search-text {
  padding: 0.26667rem 0.42667rem 0 0.42667rem;
}
.user-card {
  margin-top: 15px;
  display: flex;
  align-items: center;
  padding: 10px;
  background: #f7f8fa;
  border-radius: 8px;
}
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}
.nickname {
  font-size: 16px;
  color: #333;
}

.empty {
  padding: 40px 0;
  text-align: center;
  color: #999;
  font-size: 14px;
}

/* 列表核心：让 is-link 垂直居中 */
::v-deep .van-cell {
  display: flex;
  align-items: center;
}
::v-deep .van-cell__right-icon {
  display: flex;
  align-items: center;
  height: 100%;
}
.history-item {
  padding: 10px 0.42667rem;
  border-top: 1px solid #f5f5f5;
}
.history-item:active {
  background: #f5f5f5;
}
</style>